import React from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import html from "react-inner-html";
import {translation} from "../../../../I18n/i18n";
import {generateTitles} from "../../../FileGenerator/utils";


const EducationAndTrainingRead = (props) => {

    return (

        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{translation(props.lang, "Education")}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{display:"block"}} >
                    {props.element.Education.List !== undefined && props.element.Education.List.length !== 0 ? (
                        generateTitles(props.element.Education.List).map((e,i) =>
                            <p key={i}>{e.label}<br/></p>
                        )
                    ) : <div {...html(props.element.Education.Description._text)} />}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>{translation(props.lang, "Training")}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{display:"block"}}>
                    {props.element.Training.List !== undefined && props.element.Training.List.length !== 0 ? (
                        generateTitles(props.element.Training.List).map((e,i) =>
                            <p key={i}>{e.label}<br/></p>
                        )
                    ) :  <div {...html(props.element.Training.Description._text)} />}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <Typography>{translation(props.lang, "Certifications")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {props.element.Certification.List !== undefined && props.element.Certification.List.length !== 0 ? (
                        generateTitles(props.element.Certification.List).map((e,i) =>
                            <p key={i}>{e.label}<br/></p>
                        )
                    ) :   <div {...html(props.element.Certification.Description._text)} />}
                </AccordionDetails>

            </Accordion>
        </div>
    )
};

export default EducationAndTrainingRead;
